import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Grid,
  CircularProgress,
  Button,
  Paper,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { handleAxiosError } from "../../config/action-config";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { showAlert } from "../../actions/alert";
import {
  deleteWorkingStatus,
  getWorkingStatusById,
  updateWorkingStatus,
} from "../../api/workingStatus";

const deleteApis = {
  WORKING_STATUS: deleteWorkingStatus,
};

const emptyWorkingStatusData = {
  id: "",
  status: "",
  emp_email: "",
  clock_in_time: "",
};

export default function WorkingStatusView() {
  const user = useSelector((state) => state.user);
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [workingStatusData, setWorkingStatusData] = useState(
    emptyWorkingStatusData
  );
  const [deletingContent, setDeletingContent] = useState({ table: "", row: 0 });
  const [editDisabled, setEditDisabled] = useState(true);
  const onworkingStatusDataUpdate = () => {
    updateWorkingStatus(
      workingStatusData.id,
      getUpdatableWorkingStatusData(workingStatusData),
      user.token
    )
      .then((res) => {
        loadMasterData();
        dispatch(showAlert(res.data.msg));
        setEditDisabled(true);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  const loadMasterData = () => {
    getWorkingStatusById(params.id, user.token)
      .then((res) => {
        // const apiStatusValue = res.data.data[0].status;
        // const displayStatusValue =
        //   apiStatusValue === "WFH"
        //     ? "Working"
        //     : apiStatusValue === "L"
        //     ? "On Leave"
        //     : apiStatusValue;

        // setWorkingStatusData({
        //   ...res.data.data[0],
        //   status: displayStatusValue,
        // });
        setWorkingStatusData(res.data.data[0]);
        setLoading(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  useEffect(() => {
    if (!params.id) {
    } else loadMasterData();
  }, [params.id]);

  const changeUpdateData = (e) => {
    let newValue = e.target.value;

    // Map the selected option to the corresponding value
    // if (newValue === "On Leave") {
    //   newValue = "L";
    // } else if (newValue === "Working") {
    //   newValue = "WFH";
    // }

    setWorkingStatusData((prev) => ({
      ...prev,
      [e.target.name]: newValue,
    }));
  };

  const onDelete = () => {
    const deleteApi = deleteApis[deletingContent.table];
    deleteApi(deletingContent.row, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setDeletingContent({ type: "", row: 0 });
        if (deletingContent.table === "WORKING_STATUS") {
          navigate("/working-status");
        }
        // else if (deletingContent.table === 'EMPLOYEE') { loadMasterData(); }
        // else if (deletingContent.table == 'TASK') { loadTimesheetData(); }
      })
      .catch((err) => {
        setDeletingContent({ table: "", row: 0 });
        handleAxiosError(err, dispatch);
      });
  };
  const workingStatusOptions = ["On Leave", "Working"];
  return loading ? (
    <Loading />
  ) : (
    <Box sx={{ flexGrow: 1 }}>
      <Paper sx={{ p: "1rem" }}>
        <Box
          sx={{
            display: "flex",
            pb: 1,
            mb: 1,
            borderBottom: 1,
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">Working Status Details</Typography>
          <Box sx={{ display: "flex", columnGap: 1 }}>
            {/* <Button
              variant="contained"
              onClick={() => {
                setEditDisabled((prev) => !prev);
              }}
              style={{ padding: "5px 7px" }}
            >
              {editDisabled ? "Edit" : "Cancel"}
            </Button> */}
            <Button
              variant="contained"
              onClick={() => {
                navigate(-2);
              }}
              style={{ padding: "5px 7px" }}
            >
              Go Back
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setDeletingContent({
                  table: "WORKING_STATUS",
                  row: workingStatusData.id,
                });
              }}
            >
              Delete
            </Button>
          </Box>
        </Box>
        <Grid container columnSpacing={2} rowSpacing={1} sx={{ pt: "1rem" }}>
          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Working Status
              </InputLabel>
              <Select
                name="status"
                value={workingStatusData.status}
                onChange={changeUpdateData}
                label="Working Status"
                // disabled={editDisabled}
              >
                <MenuItem value="WFH">Working</MenuItem>
                <MenuItem value="L">On Leave</MenuItem>
              </Select>
            </FormControl>
            {/* <FormControl component="fieldset" fullWidth>
              <FormLabel component="legend">Working Status</FormLabel>
              <RadioGroup
                name="status"
                value={workingStatusData.status}
                onChange={changeUpdateData}
                row
              >
                {workingStatusOptions.map((option, index) => (
                  <FormControlLabel
                    key={index}
                    value={option}
                    control={<Radio />}
                    label={option}
                    disabled={editDisabled}
                  />
                ))}
              </RadioGroup>
            </FormControl> */}
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              size="small"
              margin="dense"
              name="emp_email"
              fullWidth
              value={workingStatusData.emp_email}
              onChange={changeUpdateData}
              label="Employee Email"
              type="text"
              variant="outlined"
              disabled
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              size="small"
              margin="dense"
              name="email"
              fullWidth
              value={formattedDate(workingStatusData.clock_in_time)}
              onChange={changeUpdateData}
              label="Clock In Time"
              type="text"
              variant="outlined"
              disabled
            />
          </Grid>
          <Grid item xs={12}>
            {/* {editDisabled ? (
              <></>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "right",
                  columnGap: 1,
                  ml: "auto",
                }}
              > */}
            <Button
              variant="contained"
              onClick={onworkingStatusDataUpdate}
              style={{ padding: "5px 7px" }}
              className="blue-button"
            >
              Update
            </Button>
            {/* </Box>
            )} */}
          </Grid>
        </Grid>
      </Paper>

      <DeleteDialog
        deletingContent={deletingContent}
        setDeletingContent={setDeletingContent}
        onDelete={onDelete}
      />
    </Box>
  );
}

function DeleteDialog({ deletingContent, setDeletingContent, onDelete }) {
  return (
    <Dialog
      open={Boolean(deletingContent.table)}
      onClose={() => {
        setDeletingContent({ table: "", row: 0 });
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Confirm Delete</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          This will delete the row in table {deletingContent.table} with id:{" "}
          {deletingContent.row}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setDeletingContent({ table: "", row: 0 });
          }}
          className="cancel-button"
        >
          Cancel
        </Button>
        <Button onClick={onDelete} autoFocus className="blue-button">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function formatDate(date) {
  if (!date) return "Not Provided";
  let d = new Date(date);
  return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
}

function Loading() {
  return (
    <div className="page d-flex">
      <div className="m-auto text-center">
        <CircularProgress />
      </div>
    </div>
  );
}

function getUpdatableWorkingStatusData(data) {
  return {
    id: data.id,
    status: data.status,
    emp_email: data.emp_email,
    clock_in_time: data.clock_in_time,
  };
}
function formattedDate(inputDate) {
  // Create a Date object from the input string
  const date = new Date(inputDate);

  // Define months in abbreviated form
  const months = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];

  // Get the day, month, and year components
  const day = date.getDate().toString().padStart(2, "0");
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  // Construct the formatted date string
  const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;

  return formattedDate;
}
// if (newValue === "On Leave") {
//   newValue = "L";
// } else if (newValue === "Working") {
//   newValue = "WFH";
// }
